import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { OrderFilterForm } from "Order/Components/Form/OrderFilterForm";
import { Close, FilterList } from "@mui/icons-material";
import { Box, Button, Drawer, Stack, Typography } from "@mui/material";
import { useState } from "react";

const orderResource = Resources.base.order.shared;

export const OrderFilterWidget = () => {
	const { t } = useResource();
	const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

	const handleFilterDrawerOpen = () => {
		setIsFilterDrawerOpen(true);
	};

	return (
		<>
			<Button title={t(orderResource.filters)} onClick={handleFilterDrawerOpen}>
				<FilterList />
			</Button>
			<Drawer
				anchor="right"
				open={isFilterDrawerOpen}
				onClose={() => setIsFilterDrawerOpen(false)}
				PaperProps={{
					sx: {
						p: 4,
						width: {
							xs: "100%",
							sm: "85%",
							md: "40%",
							lg: "35%",
							xl: "25%",
						},
					},
				}}
			>
				<Stack flexDirection="row" justifyContent="space-between">
					<Typography variant="h4">{t(orderResource.filters)}</Typography>
					<Box
						onClick={() => setIsFilterDrawerOpen(false)}
						sx={{ cursor: "pointer" }}
					>
						<Close />
					</Box>
				</Stack>
				<OrderFilterForm setIsFilterDrawerOpen={setIsFilterDrawerOpen} />
			</Drawer>
		</>
	);
};
